import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function BankAccountBasicInfoComponent({
  handleInnerFormChange, selectedBankAccounts, id
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              isDisabled={id !== '0'}
              label="Account Number"
              name="AccountNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'AccountNumber',
                )
              }}
              type="text"
              value={selectedBankAccounts?.AccountNumber}
            />
            <InputContainer
              isDisabled={id !== '0'}
              label="Bank Name"
              name="BankName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'BankName',
                )
              }}
              type="text"
              value={selectedBankAccounts?.BankName}
            />
            <InputContainer
              isDisabled={id !== '0'}
              label="Branch"
              name="Branch"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Branch',
                )
              }}
              type="text"
              value={selectedBankAccounts?.Branch}
            />
            <InputContainer
              label="Date"
              name="Date"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Date'
                )
              }}
              type="date"
              value={selectedBankAccounts?.Date}
            />
            <InputContainer
              label="Deposited Amount"
              name="DepositedAmount"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DepositedAmount'
                );
              }}
              type="number"
              value={selectedBankAccounts?.DepositedAmount}
            />
            {id > 0 && (
              <InputContainer
                isDisabled={selectedBankAccounts?.BalanceAmount}
                label="Balance Amount"
                name="BalanceAmount"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'BalanceAmount'
                  );
                }}
                type="number"
                value={selectedBankAccounts?.BalanceAmount}
              />
            )}
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Information"
      />
    </>
  )
}